import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
//MUI
import {makeStyles} from '@material-ui/styles';
import {Grid, Button, IconButton, TextField, Link, Typography} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import FormHelperText from '@material-ui/core/FormHelperText';
//DS
import {loadingModal, openMsg} from 'redux-app';
import {useLogIn} from 'hooks';
import {baseName} from 'config/keys';
const backgroundImage = `url(${baseName}/images/auth.jpg)`;
//Estilos
const schema = {
   usuario: {
      presence: {allowEmpty: false, message: 'is required'},
      length: {
         maximum: 64
      }
   },
   password: {
      presence: {allowEmpty: false, message: 'is required'},
      length: {
         maximum: 128
      }
   }
};

const useStyles = makeStyles(theme => ({
   root: {
      backgroundColor: theme.palette.background.default,
      height: '100%'
   },
   grid: {
      height: '100%'
   },
   quoteContainer: {
      [theme.breakpoints.down('md')]: {
         display: 'none'
      }
   },
   quote: {
      backgroundColor: theme.palette.neutral,
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundImage: backgroundImage,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center'
   },
   quoteInner: {
      textAlign: 'center',
      flexBasis: '600px'
   },
   quoteText: {
      color: theme.palette.white,
      fontWeight: 300
   },
   name: {
      marginTop: theme.spacing(3),
      color: theme.palette.white
   },
   content: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
   },
   contentHeader: {
      display: 'flex',
      alignItems: 'center',
      paddingTop: theme.spacing(5),
      paddingBototm: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
   },
   contentBody: {
      flexGrow: 1,
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
         justifyContent: 'center'
      }
   },
   form: {
      paddingLeft: 100,
      paddingRight: 100,
      paddingBottom: 125,
      flexBasis: 700,
      [theme.breakpoints.down('sm')]: {
         paddingLeft: theme.spacing(2),
         paddingRight: theme.spacing(2)
      }
   },
   title: {
      marginTop: theme.spacing(3),
      justifySelf: 'center'
   },
   textField: {
      marginTop: theme.spacing(2)
   },
   signInButton: {
      margin: theme.spacing(2, 0)
   }
}));

function SignIn({history, contactanosPage, mensajeIntro, razonSocial, callbackLoading, callbackError}) {
   /*
 Estados de control
 */
   const classes = useStyles();

   const [formState, setFormState] = useState({
      isValid: false,
      values: {},
      touched: {},
      errors: {}
   });

   const [logResult, setLogResult] = useState('');

   /*
  Queries
  */
   const logIn = useLogIn(setLogResult);

   /*
  Efectos de control
  */
   useEffect(() => {
      const errors = validate(formState.values, schema);

      setFormState(formState => ({
         ...formState,
         isValid: errors ? false : true,
         errors: errors || {}
      }));
   }, [formState.values]);

   /*
  Funciones de control
  */
   const handleBack = () => {
      history.goBack();
   };

   const handleChange = event => {
      event.persist();

      setFormState(formState => ({
         ...formState,
         values: {
            ...formState.values,
            [event.target.name]:
               event.target.type === 'checkbox' ? event.target.checked : event.target.value
         },
         touched: {
            ...formState.touched,
            [event.target.name]: true
         }
      }));
   };

   const handleSignIn = event => {
      event.preventDefault();
      logIn({
         variables: {
            user: formState.values.usuario,
            pass: formState.values.password
         }
      });
   };

   const hasError = field => (formState.touched[field] && formState.errors[field] ? true : false);

   return (
      <div className={classes.root}>
         <Grid className={classes.grid} container>
            <Grid className={classes.quoteContainer} item lg={5}>
               <div className={classes.quote}>
                  <div className={classes.quoteInner}>
                     <Typography className={classes.quoteText} variant="h1">
                        {/*mensajeIntro*/}
                     </Typography>

                  </div>
               </div>
            </Grid>
            <Grid className={classes.content} item lg={7} xs={12}>
               <div className={classes.content}>
                  <div className={classes.contentHeader}>
                     <IconButton onClick={handleBack}>
                        <ArrowBackIcon />
                     </IconButton>
                  </div>
                  <div className={classes.contentBody}>
                     <form className={classes.form} onSubmit={handleSignIn}>
                        <Typography className={classes.title} variant="h2">
                           Iniciar Sesión
                        </Typography>
                        <TextField
                           className={classes.textField}
                           error={hasError('usuario')}
                           fullWidth
                           helperText={hasError('usuario') ? formState.errors.usuario[0] : null}
                           label="Usuario"
                           name="usuario"
                           onChange={handleChange}
                           type="text"
                           value={formState.values.usuario || ''}
                           variant="outlined"
                        />
                        <TextField
                           className={classes.textField}
                           error={hasError('password')}
                           fullWidth
                           helperText={hasError('password') ? formState.errors.password[0] : null}
                           label="Password"
                           name="password"
                           onChange={handleChange}
                           type="password"
                           value={formState.values.password || ''}
                           variant="outlined"
                        />
                        <FormHelperText error={logResult !== ''}>{logResult}</FormHelperText>
                        <Button
                           className={classes.signInButton}
                           color="primary"
                           disabled={!formState.isValid}
                           fullWidth
                           size="large"
                           type="submit"
                           variant="contained"
                        >
                           Ingrese ahora
                        </Button>
                        <Typography color="textSecondary" variant="body1">
                           ¿No está registrado?{' '}
                           <Link href={contactanosPage} target="#">
                              Contáctenos!
                           </Link>
                        </Typography>
                     </form>
                  </div>
               </div>
            </Grid>
         </Grid>
      </div>
   );
}

SignIn.propTypes = {
   history: PropTypes.object
};

function mapStateToProps(state) {
   return {
      contactanosPage: state.appGen.contactanosPage,
      mensajeIntro: state.appGen.mensajeIntro,
      razonSocial: state.appGen.razonSocial,
      logResult: state.auth.msg
   };
}

function mapDispatchToProps(dispatch) {
   return {
      callbackLoading: loading => {
         dispatch(loadingModal(loading));
      },
      callbackError: msg => {
         dispatch(openMsg(msg));
      }
   };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SignIn));
